<script>
import { MatomoHelper } from "@/helpers";
import { MatomoEventAction, MatomoEventCategory } from "@/types";

export default {
  name: "ArticleContentCollapser",
  props: {
    isCollapsible: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default
      default: true
    }
  },
  data() {
    return {
      isForceExpanded: false,
      contentHeight: null
    };
  },
  computed: {
    isExpanded() {
      return !this.isCollapsible || this.isForceExpanded || !this.contentHeight;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.contentHeight = this.$refs?.content?.offsetHeight;
    });
  },
  methods: {
    expand() {
      this.isForceExpanded = true;
    },
    trackUnfoldArticleOnFuzzyClick() {
      MatomoHelper.sendEvent(
        MatomoEventCategory.Search,
        MatomoEventAction.ClickUnfoldArticleOnFuzzy,
        "Clicked unfold article on fuzzy"
      );
    }
  }
};
</script>

<template>
  <div class="article-content-collapser">
    <div ref="content" class="article-content-collapser__content">
      <slot v-if="isExpanded" />
    </div>

    <button
      v-if="!isExpanded"
      class="article-content-collapser__button"
      :aria-expanded="isExpanded"
      @click="expand(), trackUnfoldArticleOnFuzzyClick()"
    >
      [+]&nbsp;
      <span class="article-content-collapser__button-text">
        {{ $t("article.expand") }}
      </span>
    </button>
  </div>
</template>
